export default [
    {
        path: 'entrada-inicial',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-entrada-inicial' */
            '@/views/almoxarifado/entrada-inicial/Index'
        ),
        redirect: 'entrada-inicial/index',
        children: [
            {
                name: 'almoxarifado-entrada-inicial-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-entrada-inicial' */
                    '@/views/almoxarifado/entrada-inicial/List.vue'
                ),
            },
        ],
    },
]